import React, { useState } from 'react';
import { ArrowLeft, Send, Loader2, MapPin, DollarSign, Clock, CheckCircle } from 'lucide-react';
import axios from 'axios';
import './CandidateSubmissionForm.css'; // reuse the rcsf-* styles

export default function CandidateJobApplicationForm({ job, candidateId, profile, onBack, onSubmitted }) {
  const [formData, setFormData] = useState({
    noticePeriod: '',
    education: profile?.certification || '',
    currentlyWorking: 'Yes',
  });
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [submittedData, setSubmittedData] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/candidate/apply`,
        { jobId: job._id, candidateUserId: candidateId, candidateData: formData }
      );
      setSubmittedData(data);
      setShowSuccessModal(true);
    } catch (err) {
      alert(err.response?.data?.message || 'Application failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

    const closeSuccessModal = () => {
    setShowSuccessModal(false);
    onSubmitted(submittedData);
  };

  return (
    <div className="rcsf-wrapper">
      <div className="rcsf-topbar">
        <button className="rcsf-back-btn" onClick={onBack} disabled={isLoading}>
          <ArrowLeft size={14} /> Back
        </button>
        <div className="rcsf-topbar-title">
          <h3>Apply — {job?.role}</h3>
          <p><span>{job?.companyName}</span>{job?.location ? ` · ${job.location}` : ''}</p>
        </div>
      </div>

      <div className="rcsf-body">
        <div className="rcsf-left">
          <form id="cjaf-form" onSubmit={handleSubmit}>
            <div className="rcsf-section">
              <div className="rcsf-section-header">
                <div className="rcsf-section-number">1</div>
                <h4>Confirm Your Details</h4>
              </div>
              <div className="rcsf-section-body">
                <p style={{ color: '#64748b', fontSize: '0.85rem', marginBottom: '16px' }}>
                  We'll use your profile info ({profile?.fullName || profile?.username}, {profile?.email}) for this application. Add a few job-specific details below.
                </p>
                <div className="rcsf-grid-2">
                  <div className="rcsf-group">
                    <label className="rcsf-label">Currently Working?</label>
                    <select className="rcsf-select" name="currentlyWorking" value={formData.currentlyWorking} onChange={handleChange}>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                  <div className="rcsf-group">
                    <label className="rcsf-label">Notice Period</label>
                    <input className="rcsf-input" type="text" name="noticePeriod" value={formData.noticePeriod} onChange={handleChange} placeholder="e.g. 30 Days" />
                  </div>
                </div>
                <div className="rcsf-group">
                  <label className="rcsf-label">Education</label>
                  <input className="rcsf-input" type="text" name="education" value={formData.education} onChange={handleChange} placeholder="e.g. B.Tech Computer Science" />
                </div>
              </div>
            </div>
          </form>
        </div>

        <div className="rcsf-right">
          <div className="rcsf-job-card">
            <div className="rcsf-job-card-label">Applying For</div>
            <div className="rcsf-job-card-role">{job?.role}</div>
            <div className="rcsf-job-card-company">{job?.companyName}</div>
            <div className="rcsf-job-card-meta">
              {job?.location && <div className="rcsf-job-card-meta-row"><MapPin size={12} /> {job.location}</div>}
              {job?.ctc && <div className="rcsf-job-card-meta-row"><DollarSign size={12} /> {job.ctc}</div>}
              {job?.applyByDate && <div className="rcsf-job-card-meta-row"><Clock size={12} /> Apply by {job.applyByDate}</div>}
            </div>
          </div>

          <button className="rcsf-submit-btn" form="cjaf-form" type="submit" disabled={isLoading}>
            {isLoading ? <><Loader2 size={16} className="rcsf-spin" /> Applying…</> : <><Send size={15} /> Apply Now</>}
          </button>
          <p className="rcsf-submit-note">Your existing resume and profile details will be attached automatically.</p>
        </div>
      </div>
        {showSuccessModal && (
        <div className="rcsf-modal-overlay">
          <div className="rcsf-modal">
            <CheckCircle size={40} className="rcsf-modal-icon" />
            <h3>Application Submitted!</h3>
            <p className="rcsf-modal-highlight">
              You'll receive an assessment link shortly — please complete it. 
              If you don't see it, please check your spam folder.
            </p>
            <p className="rcsf-modal-thanks">Thanks for applying!</p>
            <button className="rcsf-submit-btn" onClick={closeSuccessModal}>
              Got it
            </button>
          </div>
        </div>
      )}
    </div>
  );
}